module.exports = __webpack_public_path__ + "fd2ed1071718753de3126abb8ee65e55.png";